const StyledGreeting = ({text}) => {
    return <p className="productos__heading">{text}</p>
}
 
export default StyledGreeting;